{
  "maximum": "Maximum",
  "minimum": "Minimum"
}
